'use client';

import { Title } from 'types';
import { Box } from '@/components/layout/box';
import TitleDetails from '@/components/product/title-details';

interface DiscoverMoreClientProps {
  titleData: Title;
}
export default function DiscoverMoreClient({ titleData }: DiscoverMoreClientProps) {
  return (
    <Box>
      <TitleDetails title={titleData} key={4} />
    </Box>
  );
}